<template>
  <page
    layout="single"
    class="rentalBalance"
    no-padding
  >
    <div class="rentalBalance__title">
      <md-icon name="info" />

      <h4>Attention votre solde est débiteur</h4>
    </div>

    <p class="rentalBalance__subtitle">
      Vous pouvez régler tout ou une partie de votre loyer par carte bancaire en utilisant notre espace bancaire sécurisé
    </p>

    <p class="rentalBalance__label">
      Je souhaite effectuer un virement de :
    </p>

    <div class="rentalBalance__form">
      <div class="rentalBalance__form-input">
        <el-input placeholder="1331€" />
      </div>
      <div class="rentalBalanace__form-button">
        <el-button>Payer</el-button>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  name: 'RentalBalance'
}
</script>

<style lang="scss" scoped>
$c: '.rentalBalance';

#{$c} {
  padding: 26px !important;
  line-height: 200%;

  &__title {
    display: flex;

    i {
      position: relative;
      top: 5px;
    }

    h4 {
      padding-left: 5px;
      font-size: 22px !important;
    }
  }

  &__subtitle {
    color: #909399;
  }

  &__label {
    font-size: 18px;
  }

  &__form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    &-input {
      width: 100%;
      padding-right: 24px;
    }

    &-button {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>